module.exports = __webpack_public_path__ + "assets/240f55ca38cb0e43b3daf1143bcd4593.png";